import { makeStyles } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';

export default makeStyles((theme: typeof muiTheme) => ({
    root: { width: 'fit-content' as const },
    text: {
        padding: '.15rem .4rem',
        fontSize: '13.5px',
        color: theme?.app?.applicationColors.enumColors.black || '#000',
        backgroundColor: '#E6E5E5',
        borderRadius: '3px'
    }
}));